import { Helmet } from 'react-helmet';
const MovieHelmet = (props) => {
  return (
    <Helmet>
      <title>{props.title}</title>
      <meta name="title" content="DS Movies App" />
      <meta name="description" content={props.discripction}/>
      {/* Open Graph / Facebook */}
      {/* <meta property="og:type" content="website" />
      <meta property="twitter:url" content={`https://sombolmv.netlify.app/detail/movies/`} />
      <meta property="og:title" content="" />
      <meta property="og:description" content=""/>
      <meta property="og:image" content=""/> */}
      {/* Twitter */}
      {/* <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={`https://sombolmv.netlify.app/detail/movies/`} />
      <meta property="twitter:title" content="" />
      <meta property="twitter:description" content=""/>
      <meta property="twitter:image" content=""/> */}
    </Helmet>
  )
}

export default MovieHelmet